import '../../App.css'
import React from 'react'

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <div className='footer'>
            © {currentYear} <a href="https://smartdemand.com.br/" target="_blank" className="footer-link fw-bolder"> Smart Demand</a>
        </div>
    )
}

export default Footer